import Review101 from "../../../../src/content/reviewer/overview/review-101.mdx";
import QuickInstall from "../../../../src/content/reviewer/setup/quick-install.mdx";
import * as React from 'react';
export default {
  Review101,
  QuickInstall,
  React
};